module.exports = __webpack_public_path__ + "static/media/ABCDE-vertical.8b5f75d6.png";